import { Grid } from '@mui/material'
import BreadCrumbs, { Summary } from '../benthosPages/breadcrumbs/BreadCrumbs'

interface StatusBarParams {
  crumbs: Summary
  children?: any
}

export default function StatusBar({ crumbs, children }: StatusBarParams) {
  return (
    <Grid
      container
      spacing={3}
      alignItems={{ md: 'center', sm: 'center', xs: 'center' }}
      direction={{ xs: 'column', sm: 'column', md: 'row' }}
      justifyContent={{ xs: 'center', sm: 'space-between', md: 'space-between' }}
      marginBottom={'5px'}
    >
      <Grid item sm={12} xs={12} md={4}>
        {crumbs ? <BreadCrumbs summary={crumbs} /> : null}
      </Grid>
      <Grid item sm={12} xs={12} md={4}>
        {children}
      </Grid>
    </Grid>
  )
}
